module.exports = __webpack_public_path__ + "img/hr-brown-fluff-19.86a2c7bd.png";